import '../css/styles.scss'
import htmx from 'htmx.org'
import Site from '../lib/Site.js'

window.htmx = htmx

if (document.body.id !== 'form-builder-form') {
	window._site = new Site()
}
